import React from 'react';

import { HealthandNutrition3and42025 } from '../views';

const Nep2020Guildeline = () => {
  return <HealthandNutrition3and42025 />;
};

export default Nep2020Guildeline;
